// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/create_prop.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionProp } from "./vision_prop_pb";
import { file_vision_shotlist_v1_vision_prop } from "./vision_prop_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/create_prop.proto.
 */
export const file_vision_shotlist_v1_create_prop: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvY3JlYXRlX3Byb3AucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEihAEKEUNyZWF0ZVByb3BSZXF1ZXN0EkMKBnBhcmFtcxgBIAEoCzIzLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuQ3JlYXRlUHJvcFJlcXVlc3QuUGFyYW1zGioKBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEgwKBG5hbWUYAiABKAkimQEKEkNyZWF0ZVByb3BSZXNwb25zZRJECgZyZXN1bHQYASABKAsyNC5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkNyZWF0ZVByb3BSZXNwb25zZS5SZXN1bHQaPQoGUmVzdWx0EjMKBHByb3AYASABKAsyJS5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvblByb3BiBnByb3RvMw", [file_vision_shotlist_v1_vision_prop]);

/**
 * @generated from message protos.vision.shotlist.v1.CreatePropRequest
 */
export type CreatePropRequest = Message<"protos.vision.shotlist.v1.CreatePropRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.CreatePropRequest.Params params = 1;
   */
  params?: CreatePropRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreatePropRequest.
 * Use `create(CreatePropRequestSchema)` to create a new message.
 */
export const CreatePropRequestSchema: GenMessage<CreatePropRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_prop, 0);

/**
 * @generated from message protos.vision.shotlist.v1.CreatePropRequest.Params
 */
export type CreatePropRequest_Params = Message<"protos.vision.shotlist.v1.CreatePropRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreatePropRequest.Params.
 * Use `create(CreatePropRequest_ParamsSchema)` to create a new message.
 */
export const CreatePropRequest_ParamsSchema: GenMessage<CreatePropRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_prop, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.CreatePropResponse
 */
export type CreatePropResponse = Message<"protos.vision.shotlist.v1.CreatePropResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.CreatePropResponse.Result result = 1;
   */
  result?: CreatePropResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreatePropResponse.
 * Use `create(CreatePropResponseSchema)` to create a new message.
 */
export const CreatePropResponseSchema: GenMessage<CreatePropResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_prop, 1);

/**
 * @generated from message protos.vision.shotlist.v1.CreatePropResponse.Result
 */
export type CreatePropResponse_Result = Message<"protos.vision.shotlist.v1.CreatePropResponse.Result"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.VisionProp prop = 1;
   */
  prop?: VisionProp | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreatePropResponse.Result.
 * Use `create(CreatePropResponse_ResultSchema)` to create a new message.
 */
export const CreatePropResponse_ResultSchema: GenMessage<CreatePropResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_prop, 1, 0);

